import { cn } from '@/lib/utils'
import { ScrollVelocityContainer, ScrollVelocityRow } from '@/components/ui/scroll-based-velocity'
import { COMPANY_LOGOS_ARRAY } from '@/components/icons/company-logos'

import Image from 'next/image'

const LOGOS_ROW = COMPANY_LOGOS_ARRAY

export function LogoVelocity() {
    return (
        <div className="relative flex w-full flex-col items-center justify-center overflow-hidden py-20">
            <h2 className="text-title-bold mx-auto max-w-[403px] text-center mb-5 md:mb-8">
                Over 6,000+ US Public Traded Companies
            </h2>
            <div
                className={cn(
                    'w-full',
                    '[mask-image:radial-gradient(600px_300px_at_center,white,transparent)]'
                )}
            >
                <ScrollVelocityContainer className="w-full">
                    {Array.from({ length: 8 }).map((_, rowIdx) => (
                        <ScrollVelocityRow
                            key={rowIdx}
                            baseVelocity={6}
                            direction={rowIdx % 2 === 0 ? 1 : -1}
                            className="py-2"
                        >
                            {LOGOS_ROW.map((item, idx) => (
                                <div
                                    key={idx}
                                    className="flex items-center gap-2.5 rounded-[999px] bg-black/5 px-5 py-[10px] mx-[5px]"
                                >
                                    <Image
                                        src={item.logo}
                                        alt={item.symbol}
                                        width={20}
                                        height={20}
                                        className="h-5 w-5 object-contain"
                                    />
                                    <span className="text-sm font-medium text-black/80">
                                        {item.symbol}
                                    </span>
                                </div>
                            ))}
                        </ScrollVelocityRow>
                    ))}
                </ScrollVelocityContainer>
                <div className="from-background pointer-events-none absolute inset-y-0 left-0 w-1/4 bg-gradient-to-r"></div>
                <div className="from-background pointer-events-none absolute inset-y-0 right-0 w-1/4 bg-gradient-to-l"></div>
            </div>
        </div>
    )
}
